import PermissionsAPI from '@/api/PermissionsAPI'
import { getRoles, getPermissions } from '@/api'

import {
  TOGGLE_PERMISSION,
  TOGGLE_CATEGORY_PERMISSIONS,
  SET_CATEGORY_PERMISSIONS,
  SET_CATEGORIES,
  SET_ROLES,
  SET_PERMISSIONS,
  SET_ROOT_CATEGORY,
  SET_SELECTED_PERMISSIONS,
  SET_USERS,
  SHOW_DELETE_USER_MODAL,
  SET_NETWORKS,
} from './constants'

const actions = {
  [TOGGLE_PERMISSION](context, { permissionId, categoryId }) {
    context.commit(TOGGLE_PERMISSION, { permissionId, categoryId })
  },
  [TOGGLE_CATEGORY_PERMISSIONS](context, { category, setValue }) {
    context.commit(TOGGLE_CATEGORY_PERMISSIONS, { category, setValue })
  },
  [SET_CATEGORY_PERMISSIONS](context, { categoryId, permissions }) {
    context.commit(SET_CATEGORY_PERMISSIONS, { categoryId, permissions })
  },
  [SET_CATEGORIES](context) {
    PermissionsAPI.getCategories().then(resp => {
      context.commit(SET_CATEGORIES, resp.data)
    })
  },
  [SET_PERMISSIONS](context) {
    getPermissions().then(resp => {
      context.commit(SET_PERMISSIONS, resp.data)
    })
  },
  [SET_ROLES](context) {
    getRoles().then(resp => {
      context.commit(SET_ROLES, resp.data)
    })
  },
  [SET_ROOT_CATEGORY](context, category) {
    context.commit(SET_ROOT_CATEGORY, category)
  },
  [SET_SELECTED_PERMISSIONS](context, permissions) {
    context.commit(SET_SELECTED_PERMISSIONS, permissions)
  },
  [SET_USERS](context) {
    PermissionsAPI.getUsers().then(resp => {
      context.commit(SET_USERS, resp.data)
    })
  },
  [SHOW_DELETE_USER_MODAL](context) {
    context.commit(SHOW_DELETE_USER_MODAL)
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/permissions/store/actions.js